import Api from '@/api/Api'
import store from '../store'

export default {

  // Logs
  async getLogList (params) {
    return store.dispatch('checkResponseApi', await Api().get('document/logs', { params }))
  },

  async createLog (data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('document/logs', data, options))
  },

  async updateLog (id, data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put(`document/logs/${id}`, data, options))
  },

  async updateLogStatus (id, data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put(`document/logs/${id}/status`, data, options))
  },

  async deleteLog (id) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete(`document/logs/${id}`, options))
  },

  // Attach Files
  async getAttachFileList (params) {
    return store.dispatch('checkResponseApi', await Api().get('document/attach-files', { params }))
  },

  async createAttachFile (data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('document/attach-files', data, options))
  },

  async deleteAttachFile (id) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete(`document/attach-files/${id}`, options))
  },

  // Activities
  async getActivityList (params) {
    return store.dispatch('checkResponseApi', await Api().get('document/activities', { params }))
  },

}



// WEBPACK FOOTER //
// ./src/api/DocumentService.js